import React, { createContext, useContext, useState, useCallback } from 'react';
import { themes, isThemeUnlocked } from '../themes/index.js';
import { trackThemeToggled } from '../utils/analytics';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [themeId, setThemeId] = useState(() => {
    return localStorage.getItem('game99_theme') || 'comic';
  });
  const [isPro, setIsPro] = useState(false);
  const [themePurchases, setThemePurchases] = useState([]);

  const setTheme = useCallback((id) => {
    if (!isThemeUnlocked(id, isPro, themePurchases)) return;
    setThemeId(id);
    localStorage.setItem('game99_theme', id);
    trackThemeToggled(id);
  }, [isPro, themePurchases]);

  const updateProStatus = useCallback((pro, purchases = []) => {
    setIsPro(pro);
    setThemePurchases(purchases);
  }, []);

  const value = {
    themeId,
    setTheme,
    themes,
    isPro,
    themePurchases,
    updateProStatus,
    isUnlocked: (id) => isThemeUnlocked(id, isPro, themePurchases),
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
